import { Toaster as SonnerToaster } from 'sonner';
import { useTranslation } from 'react-i18next';

import { useIsMobile } from '@/hooks/useIsMobile';

// UB25 — toast positioning per viewport, stack max 3, themed on DDM tokens.
// Direction follows i18n (RTL on ar).
export function Toaster() {
  const isMobile = useIsMobile();
  const { i18n } = useTranslation();
  const dir = i18n.dir() === 'rtl' ? 'rtl' : 'ltr';

  return (
    <SonnerToaster
      position={isMobile ? 'bottom-center' : 'top-right'}
      visibleToasts={3}
      closeButton
      richColors={false}
      dir={dir}
      toastOptions={{
        style: {
          background: 'var(--ddm-card-bg)',
          border: '1px solid var(--ddm-neutral-100)',
          color: 'var(--ddm-ink)',
          fontFamily: 'var(--ddm-font-sans)',
          fontSize: '0.8125rem',
          padding: '11px 14px',
          boxShadow: '0 4px 16px rgba(26, 24, 20, 0.09)',
          borderRadius: 'var(--ddm-radius-sm)',
        },
      }}
    />
  );
}
